const SAFE_OUTSIDE_SELECTORS = ['[data-sonner-toast]'];

export const isSafeOutsideTarget = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  return SAFE_OUTSIDE_SELECTORS.some((selector) => target.closest(selector));
};
